import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { Trans } from 'client/components/Trans/Trans'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type TProps = {}

const AboutPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.AboutPage)
  return (
    <div className="flex flex-1 flex-col gap-12 py-20">
      <ResponsiveBlock>
        <div className="flex flex-col gap-4">
          <Text tagName="h1" className="text-palette-white font-body---40px uppercase">
            {t('title')}
          </Text>
        </div>
      </ResponsiveBlock>
      <ResponsiveBlock>
        <div className="flex w-full flex-col gap-6">
          {Array(18)
            .fill(null)
            .map((_, index) => {
              const listNumber = index + 1
              return (
                <Text tagName="p" className="text-palette-grey--alt font-body---24px font-normal">
                  <Trans i18nKey={`list.${listNumber}.text`} ns={ClientLocaleNS.AboutPage}></Trans>
                </Text>
              )
            })}
        </div>
      </ResponsiveBlock>
    </div>
  )
}

export { AboutPageContent }
